import { useState, useEffect } from "react";

import BusinessCard from "../components/BusinessCard/BusinessCard";
import LoadScreen from "../components/LoadScreen/LoadScreen";

import styles from "./home.module.scss";
import MartinIMG from '../assets/MD.png'

const Home = () => {
    const [isLoadScreen, setIsLoadScreen] = useState(true);
    const personalData = {  
        name: 'Martin Durlak',
        role: 'President',
        phone: '6476381880',
        email: 'martin@generationmarketing.ca',
        img: MartinIMG,
        linkedInLink: 'https://www.linkedin.com/in/martindurlak/',
        routeToVCF: '/Martin_Durlak.vcf',
    }

    useEffect(() => {
        setTimeout(() => {
        setIsLoadScreen(() => false);
        
        }, 2500);
    }, []);

    return (
        <div className={styles.home_page}>
        <BusinessCard data={personalData}/>
        {!!isLoadScreen && <LoadScreen />}
        </div>
    );
};

export default Home;
